<template>
    <div>
        <div class="row no-gutters">
            <div class="col-12">
                <h2 class="order-summary__head">
                    {{ getTranslation('licence-configurator', 'product_name_subscription_renewal', {'name': product.name }) }}
                </h2>
            </div>
        </div>

        <div class="custom-table">
            <div class="row custom-table__head d-none d-sm-flex">
                <div class="col-6"><div class="custom-table__head--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'quantity') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'price') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'total') }}</div></div>
            </div>
            <div class="row eeno-gutters custom-table__body">
                <template v-for="program in sortedPrograms()" v-if="linePrice(program)">
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm-6">
                        <div class="custom-table__body--elem">{{ programName(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'quantity') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ quantity(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ linePrice(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ totalPrice(program) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                </template>
            </div>
        </div>
        <br><br>
    </div>

</template>

<script>
    export default {
        methods: {
            sortedPrograms() {
                let filtered = _.filter(this.$store.state.cart.leaseProlong[this.product.id]['info'], function(l) {
                    return (l.days !== false && l.selected === 1 );
                });
                if (_.isEmpty(filtered)) {
                    return false;
                }
                return _.orderBy(filtered, ['days', 'sort_order'], ['desc', 'desc']);
            },
            quantity(program) {
                return program.quantity;
            },
            linePrice(item) {
                return this.priceFormat(this.getProgramPrice(item.id, '', this.licenceType, item.product, 1, false, item.discount, item.days));
            },
            totalPrice(item) {
                return this.priceFormat(this.getProgramPrice(item.id, '', this.licenceType, item.product, item.quantity, false, item.discount, item.days));
            },
            programName(item) {
                let name = '';
                if (item.quantity > 1) {
                    name = item.quantity + 'x' + ' ';
                }
                name += this.getProgramName(item.id, this.product.id);
                name += " ";
                name += item.version + " ( " + item.days + " days )";

                return name;
            }
        },
        computed: {

        },
        data() {
            return {
                programs: [],
                licenceType: this.getQtyName('lease', 'cloud')
            };
        },
        props: {
            product: Object,
        }
    }
</script>
